import { Text, Rect } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
import Annotation from './annotation';

// must be defined outside of the component to avoid re-rendering loops
const defaultHandleEdit = () => {};
const FreeText = ({
  draggable,
  scale,
  pageHeight,
  offset,
  dpiScale,
  selectedID,
  annotation,
  onDragEnd,
  handleEdit: _handleEdit = defaultHandleEdit
}) => {
  var _bgColor$;
  const {
    freeTextAnnotation: {
      fontSize,
      fontName,
      text
    },
    colorString,
    textColor,
    id
  } = annotation;

  // only care about the first one
  const [box] = annTools.adaptPDFRects(scale, pageHeight, annotation, offset);

  // Background and text color logic
  let bgColor;
  let textColorRGB;
  let noBg = false;

  // Text color logic
  if (textColor) {
    textColorRGB = annTools.parseColor(textColor);
  } else if (colorString && colorString !== 'undefined undefined undefined undefined') {
    textColorRGB = annTools.parseColor(colorString);
  } else {
    textColorRGB = [0, 0, 0];
  }

  // Background color logic
  if (colorString && colorString !== 'undefined undefined undefined undefined' && textColor) {
    bgColor = annTools.parseColor(colorString);
  } else {
    noBg = true;
  }
  const bgColorRGBAString = bgColor ? `rgba(${bgColor[0]},${bgColor[1]},${bgColor[2]},${(_bgColor$ = bgColor[3]) !== null && _bgColor$ !== void 0 ? _bgColor$ : 1})` : undefined;
  const textColorRGBAString = `rgba(${textColorRGB[0]},${textColorRGB[1]},${textColorRGB[2]},${textColorRGB[3] || 1})`;

  // Use the user-set font size and scale it appropriately
  const baseFontSize = fontSize || 14; // Use the user-set font size or default to 14
  const adjustedFontSize = baseFontSize * scale / dpiScale;

  // default to 'Text' if the text value is null or empty
  const textValue = text && text.length ? text : 'Text';
  return /*#__PURE__*/React.createElement(Annotation, {
    scalable: true,
    draggable: draggable,
    box: box,
    selectedID: selectedID,
    annotationID: id,
    dpiScale: dpiScale,
    scale: scale,
    onDragEnd: onDragEnd,
    onDragMove: _handleEdit
  }, /*#__PURE__*/React.createElement(Rect, {
    x: box.x / dpiScale,
    y: box.y / dpiScale,
    width: box.w / dpiScale,
    height: box.h / dpiScale,
    fill: noBg ? undefined : bgColorRGBAString
  }), /*#__PURE__*/React.createElement(Text, {
    key: `${id}-0`,
    x: box.x / dpiScale,
    y: box.y / dpiScale,
    width: box.w / dpiScale,
    height: box.h / dpiScale,
    fontFamily: fontName,
    fontSize: adjustedFontSize,
    lineHeight: 1.15 // to match pdfkit doc's `lineGap` in server/pdfgen and ios' Core Text
    ,
    fill: textColorRGBAString,
    align: "left",
    text: textValue,
    wrap: "word",
    ellipsis: true
  }));
};
FreeText.propTypes = {
  annotation: PropTypes.shape({
    colorString: PropTypes.string,
    textColor: PropTypes.string,
    id: PropTypes.string,
    freeTextAnnotation: PropTypes.shape({
      fontSize: PropTypes.number,
      fontName: PropTypes.string,
      text: PropTypes.string
    })
  }).isRequired,
  dpiScale: PropTypes.number.isRequired,
  draggable: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func,
  offset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  pageHeight: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired,
  selectedID: PropTypes.string.isRequired
};
export default FreeText;